import { px2rem, H1RegularStyle, H1BoldStyle, H2RegularStyle, H2BoldStyle, H3RegularStyle, H3BoldStyle, H4RegularStyle, H4BoldStyle, H5RegularStyle, H5BoldStyle, H6RegularStyle, H6BoldStyle, H7RegularStyle, H7BoldStyle, H8RegularStyle, H8BoldStyle, H9RegularStyle, H9BoldStyle, H10RegularStyle, H10BoldStyle, B1RegularStyle, B1BoldStyle, pB1RegularStyle, pB1BoldStyle, B2RegularStyle, B2BoldStyle, pB2RegularStyle, pB2BoldStyle, B3RegularStyle, B3BoldStyle, pB3RegularStyle, pB3BoldStyle, B4RegularStyle, B4BoldStyle, pB4RegularStyle, pB4BoldStyle, CaptionRegularStyle } from '@moim/common';
import styled, { css } from 'styled-components';

var baseWrapperStyle = css(["display:inline-block;white-space:pre-wrap;width:100%;", ";", ";", ";", ";", ";", " ", " ", " &[role=\"button\"]:hover{text-decoration:underline;}"], function (props) {
  return props.align && css(["text-align:", ";"], props.align);
}, function (props) {
  return props.color ? css(["color:", ";"], props.theme.getColorByAlias(props.color)) : css(["color:", ";"], props.theme.colorV2.colorSet.grey800);
}, function (props) {
  var _a;
  return ((_a = props.border) === null || _a === void 0 ? void 0 : _a.radius) ? css(["border-radius:", ";"], px2rem(props.border.radius)) : undefined;
}, function (props) {
  var _a;
  return ((_a = props.border) === null || _a === void 0 ? void 0 : _a.thickness) ? css(["border-width:", ";"], px2rem(props.border.thickness)) : undefined;
}, function (props) {
  var _a;
  return ((_a = props.border) === null || _a === void 0 ? void 0 : _a.color) ? css(["border-color:", ";"], props.theme.getColorByAlias(props.border.color)) : undefined;
}, function (props) {
  return props.weight && css(["font-weight:", ";"], props.weight);
}, function (props) {
  return props.fontFamily && css(["font-family:", ";"], props.fontFamily);
}, function (props) {
  return props.letterSpacing !== undefined ? css(["letter-spacing:", ";"], px2rem(props.letterSpacing)) : undefined;
});
/**
 * HEADING 1
 */
var H1Regular = styled.h1.withConfig({
  displayName: "H1Regular",
  componentId: "sc-l574fb-0"
})(["", " display:block;", ""], baseWrapperStyle, H1RegularStyle);
var H1Bold = styled.h1.withConfig({
  displayName: "H1Bold",
  componentId: "sc-l574fb-1"
})(["", " display:block;", ""], baseWrapperStyle, H1BoldStyle);
/**
 * HEADING 2
 */
var H2Regular = styled.h2.withConfig({
  displayName: "H2Regular",
  componentId: "sc-l574fb-2"
})(["", " display:block;", ""], baseWrapperStyle, H2RegularStyle);
var H2Bold = styled.h2.withConfig({
  displayName: "H2Bold",
  componentId: "sc-l574fb-3"
})(["", " display:block;", ""], baseWrapperStyle, H2BoldStyle);
/**
 * HEADING 3
 */
var H3Regular = styled.h3.withConfig({
  displayName: "H3Regular",
  componentId: "sc-l574fb-4"
})(["", " display:block;", ""], baseWrapperStyle, H3RegularStyle);
var H3Bold = styled.h3.withConfig({
  displayName: "H3Bold",
  componentId: "sc-l574fb-5"
})(["", " display:block;", ""], baseWrapperStyle, H3BoldStyle);
/**
 * HEADING 4
 */
var H4Regular = styled.h4.withConfig({
  displayName: "H4Regular",
  componentId: "sc-l574fb-6"
})(["", " display:block;", ";"], baseWrapperStyle, H4RegularStyle);
var H4Bold = styled.h4.withConfig({
  displayName: "H4Bold",
  componentId: "sc-l574fb-7"
})(["", " display:block;", ";"], baseWrapperStyle, H4BoldStyle);
/**
 * HEADING 5
 */
var H5Regular = styled.h5.withConfig({
  displayName: "H5Regular",
  componentId: "sc-l574fb-8"
})(["", " display:block;", ";"], baseWrapperStyle, H5RegularStyle);
var H5Bold = styled.h5.withConfig({
  displayName: "H5Bold",
  componentId: "sc-l574fb-9"
})(["", " display:block;", ";"], baseWrapperStyle, H5BoldStyle);
/**
 * HEADING 6
 */
var H6Regular = styled.h6.withConfig({
  displayName: "H6Regular",
  componentId: "sc-l574fb-10"
})(["", " display:block;", ";"], baseWrapperStyle, H6RegularStyle);
var H6Bold = styled.h6.withConfig({
  displayName: "H6Bold",
  componentId: "sc-l574fb-11"
})(["", " display:block;", ";"], baseWrapperStyle, H6BoldStyle);
/**
 * HEADING 7
 */
var H7Regular = styled.div.withConfig({
  displayName: "H7Regular",
  componentId: "sc-l574fb-12"
})(["", " display:block;", ";"], baseWrapperStyle, H7RegularStyle);
var H7Bold = styled.div.withConfig({
  displayName: "H7Bold",
  componentId: "sc-l574fb-13"
})(["", " display:block;", ";"], baseWrapperStyle, H7BoldStyle);
/**
 * HEADING 8
 */
var H8Regular = styled.div.withConfig({
  displayName: "H8Regular",
  componentId: "sc-l574fb-14"
})(["", " display:block;", ";"], baseWrapperStyle, H8RegularStyle);
var H8Bold = styled.div.withConfig({
  displayName: "H8Bold",
  componentId: "sc-l574fb-15"
})(["", " display:block;", ";"], baseWrapperStyle, H8BoldStyle);
/**
 * HEADING 9
 */
var H9Regular = styled.div.withConfig({
  displayName: "H9Regular",
  componentId: "sc-l574fb-16"
})(["", " display:block;", ";"], baseWrapperStyle, H9RegularStyle);
var H9Bold = styled.div.withConfig({
  displayName: "H9Bold",
  componentId: "sc-l574fb-17"
})(["", " display:block;", ";"], baseWrapperStyle, H9BoldStyle);
/**
 * HEADING 10
 */
var H10Regular = styled.div.withConfig({
  displayName: "H10Regular",
  componentId: "sc-l574fb-18"
})(["", " display:block;", ";"], baseWrapperStyle, H10RegularStyle);
var H10Bold = styled.div.withConfig({
  displayName: "H10Bold",
  componentId: "sc-l574fb-19"
})(["", " display:block;", ";"], baseWrapperStyle, H10BoldStyle);
/**
 * Body 1
 */
var B1Regular = styled.div.withConfig({
  displayName: "B1Regular",
  componentId: "sc-l574fb-20"
})(["", " ", ";"], baseWrapperStyle, B1RegularStyle);
var B1Bold = styled.div.withConfig({
  displayName: "B1Bold",
  componentId: "sc-l574fb-21"
})(["", " ", ";"], baseWrapperStyle, B1BoldStyle);
/**
 * paragraph Body 1
 */
var PB1Regular = styled.div.withConfig({
  displayName: "PB1Regular",
  componentId: "sc-l574fb-22"
})(["", " ", ";"], baseWrapperStyle, pB1RegularStyle);
var PB1Bold = styled.div.withConfig({
  displayName: "PB1Bold",
  componentId: "sc-l574fb-23"
})(["", " ", ";"], baseWrapperStyle, pB1BoldStyle);
/**
 * Body 2
 */
var B2Regular = styled.div.withConfig({
  displayName: "B2Regular",
  componentId: "sc-l574fb-24"
})(["", " ", ";"], baseWrapperStyle, B2RegularStyle);
var B2Bold = styled.div.withConfig({
  displayName: "B2Bold",
  componentId: "sc-l574fb-25"
})(["", " ", ";"], baseWrapperStyle, B2BoldStyle);
/**
 * paragraph Body 2
 */
var PB2Regular = styled.div.withConfig({
  displayName: "PB2Regular",
  componentId: "sc-l574fb-26"
})(["", " ", ";"], baseWrapperStyle, pB2RegularStyle);
var PB2Bold = styled.div.withConfig({
  displayName: "PB2Bold",
  componentId: "sc-l574fb-27"
})(["", " ", ";"], baseWrapperStyle, pB2BoldStyle);
/**
 * Body 3
 */
var B3Regular = styled.div.withConfig({
  displayName: "B3Regular",
  componentId: "sc-l574fb-28"
})(["", " ", ";"], baseWrapperStyle, B3RegularStyle);
var B3Bold = styled.div.withConfig({
  displayName: "B3Bold",
  componentId: "sc-l574fb-29"
})(["", " ", ";"], baseWrapperStyle, B3BoldStyle);
/**
 * paragraph Body 3
 */
var PB3Regular = styled.div.withConfig({
  displayName: "PB3Regular",
  componentId: "sc-l574fb-30"
})(["", " ", ";"], baseWrapperStyle, pB3RegularStyle);
var PB3Bold = styled.div.withConfig({
  displayName: "PB3Bold",
  componentId: "sc-l574fb-31"
})(["", " ", ";"], baseWrapperStyle, pB3BoldStyle);
/**
 * Body 4
 */
var B4Regular = styled.div.withConfig({
  displayName: "B4Regular",
  componentId: "sc-l574fb-32"
})(["", " ", ";"], baseWrapperStyle, B4RegularStyle);
var B4Bold = styled.div.withConfig({
  displayName: "B4Bold",
  componentId: "sc-l574fb-33"
})(["", " ", ";"], baseWrapperStyle, B4BoldStyle);
/**
 * paragraph Body 4
 */
var PB4Regular = styled.div.withConfig({
  displayName: "PB4Regular",
  componentId: "sc-l574fb-34"
})(["", " ", ";"], baseWrapperStyle, pB4RegularStyle);
var PB4Bold = styled.div.withConfig({
  displayName: "PB4Bold",
  componentId: "sc-l574fb-35"
})(["", " ", ";"], baseWrapperStyle, pB4BoldStyle);
/**
 * LABEL
 */
var CaptionRegular = styled.label.withConfig({
  displayName: "CaptionRegular",
  componentId: "sc-l574fb-36"
})(["", " ", ";"], baseWrapperStyle, CaptionRegularStyle);
var PlainText = styled.span.withConfig({
  displayName: "PlainText",
  componentId: "sc-l574fb-37"
})(["", ";"], baseWrapperStyle);

export { B1Bold, B1Regular, B2Bold, B2Regular, B3Bold, B3Regular, B4Bold, B4Regular, CaptionRegular, H10Bold, H10Regular, H1Bold, H1Regular, H2Bold, H2Regular, H3Bold, H3Regular, H4Bold, H4Regular, H5Bold, H5Regular, H6Bold, H6Regular, H7Bold, H7Regular, H8Bold, H8Regular, H9Bold, H9Regular, PB1Bold, PB1Regular, PB2Bold, PB2Regular, PB3Bold, PB3Regular, PB4Bold, PB4Regular, PlainText };
